import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'

export const POLYGON_TOKEN_TICKERS = [Ticker.USDC]

export type PolygonTokenTicker = IterableElement<typeof POLYGON_TOKEN_TICKERS>
